var map = {
	"./bbc54yyk/logo.svg": "9f30",
	"./chaoxinxing/logo.svg": "0f44",
	"./ecshopx/logo.svg": "2249",
	"./onex/logo.svg": "1f46",
	"./yyk/logo.svg": "3473"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7d9";